/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * CreateReply dto
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto {
    /**
     * Gets or sets the identifier.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto
     */
    id?: number;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto {
    return WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

